module.exports = __webpack_public_path__ + "img/khabib-promo.db59c843.png";